import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    window.gtag("config", "G-QJ7124TS1Q", {
      page_path: location.pathname,
    });
  }, [location]);

  return null;
};

export default TrackPageView;
